import { DirectUpload } from "@rails/activestorage"
import { post } from "@rails/request.js"

export class DocumentUploader {
  constructor({ directUploadUrl, formAction, form }) {
    this.directUploadUrl = directUploadUrl
    this.formAction = formAction
    this.form = form
  }

  async uploadFile(file, { onProgress } = {}) {
    // Returns { error, blob, signedId }
    if (!file) {
      return { error: "No file provided" }
    }

    if (!this.directUploadUrl) {
      return { error: "Direct upload URL not configured" }
    }

    return new Promise((resolve) => {
      try {
        const upload = new DirectUpload(file, this.directUploadUrl, {
          directUploadWillStoreFileWithXHR: (xhr) => {
            if (onProgress) {
              xhr.upload.addEventListener("progress", event => {
                const progress = event.loaded / event.total * 100
                onProgress(progress)
              })
            }
          }
        })

        upload.create((error, blob) => {
          if (error) {
            resolve({ error: error.message || "Upload failed" })
          } else if (!blob?.signed_id) {
            resolve({ error: "Invalid upload response" })
          } else {
            resolve({ blob, signedId: blob.signed_id })
          }
        })
      } catch (error) {
        resolve({ error: error.message || "Upload initialization failed" })
      }
    })
  }

  async createDocument(signedId) {
    if (!signedId) {
      return { error: "No signed ID provided" }
    }

    if (!this.formAction) {
      return { error: "Form action URL not configured" }
    }

    const body = new FormData()
    body.append("document[original_file]", signedId)

    if (this.form) {
      const hiddenInputs = this.form.querySelectorAll('input[type="hidden"]')
      hiddenInputs.forEach(input => {
        if (input.name && input.value) {
          body.append(input.name, input.value)
        }
      })
    }

    try {
      const headers = { Accept: "text/vnd.turbo-stream.html" }
      const response = await post(this.formAction, { body, headers })

      if (!response.ok) {
        const statusText = response.statusText || "Unknown error"
        throw new Error(`Server error (${response.status}): ${statusText}`)
      }

      const html = await response.text
      return { html }
    } catch (error) {
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        return { error: "Network error: Unable to connect to server" }
      }
      return { error: error.message || "Document creation failed" }
    }
  }
}
